import host from "../host";
import axios from "axios";
import io from "socket.io-client";
// import { Observable } = require("rxjs/Observable");

class app {
  constructor() {
    this.host = host;
    this.endpoint = null;
    this.io = io(host);
    this.api = axios.create({
      baseURL: this.host,
      headers: { authtoken: localStorage.getItem("token") },
    });
    this.uploadAPI = axios.create({
      baseURL: this.host,
      headers: {
        authtoken: localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      },
    });
  }
  urlMaker(params) {
    var urlParams = "";
    if (params && params.query && Object.keys(params.query)) {
      urlParams = "?";

      Object.keys(params.query).forEach((key, i, a) => {
        var param = params.query[key];
        if (param === null) {
          param = "null";
        }

        if (key === "$select") {
          //select function
          params.query[key].forEach((skey) => {
            urlParams += `$select=${skey}`;
          });
        } else if (key === "$sort") {
          //sort function
          Object.keys(params.query[key]).forEach((skey, si, sa) => {
            urlParams += `$sort[${skey}]=${params.query[key][skey]}`;
          });
        } else if (key === "$or") {
          // console.log("found or");
          var orparams = param.map((op, i) => {
            let orkeys = Object.keys(op);
            return `${key}[${i + 1}][${orkeys[0]}]=${op[orkeys[0]]}`;
            // orkeys.map(orkey => urlParams += )
          });
          urlParams += orparams.join("&");
        } else {
          if (typeof param === "object") {
            console.log("Param is", param);
            Object.keys(param).forEach((pkey, pi, pa) => {
              // console.log(pkey);
              if (pkey === "$in") {
                urlParams += `${key}[${pkey}]=${param[pkey].join(
                  `&${key}[${pkey}]=`
                )}`;
              } else {
                urlParams += `${key}[${pkey}]=${param[pkey]}`;
              }
              if (pa.length > pi + 1) {
                urlParams += "&";
              }
            });
          } else {
            urlParams += `${key}=${params.query[key]}`;
          }
          console.log(`UrL Maker ${this.endpoint}`, a.length, i, key);
          if (a.length > i + 1) {
            urlParams += "&";
          }
        }
      });
    } else {
    }
    this.url = `${this.host}/${this.endpoint}${urlParams}`;
  }

  print(params) {
    this.urlMaker(params);
    console.log(this.url);
  }
  service(endpoint) {
    this.endpoint = endpoint;
    return {
      authenticate: (params) => this.authenticate(params),
      patch: (id, body, params) => this.patch(id, body, params),
      get: (id) => this.get(id, endpoint),
      update: (id, body, params) => this.patch(id, body, params),
      find: (params) => this.find(params),
      create: (id, body, params) => this.create(id, body, params),
      remove: (id, params) => this.remove(id, params),
      print: (params) => this.print(params),
      watch: () => this.watch(endpoint),
    };
  }
  watch(endpoint) {
    return {
      get: (id) => Promise.resolve(this.realtimeget(endpoint, id)),
      find: (params) => this.realtimefind(endpoint, params),
    };
  }
  update_api(token) {
    localStorage.setItem("token", token);
    this.api = axios.create({
      baseURL: this.host,
      headers: {
        authtoken: token,
      },
    });
  }
  api_instance() {
    return axios.create({
      baseURL: this.host,
      headers: {
        authtoken: localStorage.getItem("token"),
      },
    });
  }
  authenticate(
    params = {
      strategy: "jwt",
    }
  ) {
    if (params.strategy === "jwt") {
      this.update_api(params.accessToken);
      console.log("Authenticating");
      return this.api.get("/login").then((res) => {
        console.log("Tried to Authenticate", res);
        return res;
      });
    } else if (params.strategy === "local") {
      return this.api.post("/login", params).then((res) => {
        this.update_api(res.data.token);
        console.log("Response", res.data)
        return this.api.get("/login").then((res) => {
          console.log("User Authenticated", res);
          return res.data;
        });
      });
      // );
    }
  }
  get(id, s) {
    return Promise.resolve(this.api.get(`/${s}/${id}`).then((res) => res.data));
  }
  realtimefind(endpoint, params) {
    this.io.emit("Socket Init", endpoint);
    return this.io.on(`Realtime Service Update ${endpoint}`, () =>
      this.service(endpoint)
        .find(params)
        .then((res) => res.data)
    );
  }
  realtimeget(endpoint, id) {
    this.io.emit("Socket Init", endpoint);
    // const watcher = new Observable((observer) => {
    //   this.io.on(`Realtime Service Update ${endpoint}`, () =>
    //     this.service(endpoint)
    //       .get(id)
    //       .then((res) => observer.next(res.data))
    //   );
    // });
    // return watcher;
  }
  patch(id, body, params) {
    if (id) {
      console.log("Update Id", `/${this.endpoint}/${id}`);
      return this.api
        .put(`/${this.endpoint}/${id}`, body)
        .then((res) => res.data);
    } else if (params) {
      this.urlMaker(params);
      return this.api.put(`${this.url}`, body).then((res) => res.data);
    }
  }
  find(params) {
    this.urlMaker(params);
    console.log("request url", this.url);
    return Promise.resolve(this.api.get(`${this.url}`).then((res) => res.data));
  }
  create(body) {
    this.urlMaker();
    return this.api.post(this.url, body).then((res) => res.data);
  }
  uploadWodFiles(wonum, files) {
    const formdata = new FormData();
    formdata.append("uploads", files);
    return Promise.resolve(
      this.uploadAPI.post(`/workorders/uploads/${wonum}`, formdata)
    );
  }
  deletewodfile(id) {
    return Promise.resolve(this.api.delete(`/workorders/uploads/${id}`));
  }
  remove(id, body, params) {
    if (id) {
      return Promise.resolve(
        this.api.delete(`/${this.endpoint}/${id}`, body).then((res) => res.data)
      );
    } else if (params) {
      this.urlMaker(params);
      return Promise.resolve(
        this.api.delete(`${this.url}`, body).then((res) => res.data)
      );
    }
  }
}

export default app;



// WEBPACK FOOTER //
// ./src/services/express-client.js